/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type CartItemCTA_item$ref = any;
type CartItemImage_item$ref = any;
type CartItemPricing_item$ref = any;
type CartItemTitle_item$ref = any;
type CartQuantitySelect_item$ref = any;
type ItemFolderWrapper_item$ref = any;
type ItemHeartWrapper_item$ref = any;
export type CartItem_item$ref = any;
export type CartItem_item = {
    readonly serviceId: string | null;
    readonly isNotListed: boolean | null;
    readonly isDeleted: boolean | null;
    readonly isInProcurement?: boolean | null;
    readonly seller: {
        readonly isClosed: boolean | null;
        readonly isPending: boolean | null;
        readonly isSuspended: boolean | null;
    } | null;
    readonly firstPhotoWebPath: string | null;
    readonly title: string | null;
    readonly displayInfo: {
        readonly pricing: {
            readonly showOnHold: boolean | null;
            readonly showSold: boolean | null;
        } | null;
    } | null;
    readonly " $fragmentRefs": CartItemImage_item$ref & CartItemTitle_item$ref & CartItemPricing_item$ref & CartItemCTA_item$ref & ItemFolderWrapper_item$ref & ItemHeartWrapper_item$ref & CartQuantitySelect_item$ref;
    readonly " $refType": CartItem_item$ref;
};



const node: ReaderFragment = (function () {
    var v0 = ({
        "kind": "Variable",
        "name": "userId",
        "variableName": "userId"
    } as any), v1 = [
        ({
            "kind": "Variable",
            "name": "loadPortfolioData",
            "variableName": "loadPortfolioData"
        } as any),
        (v0 /*: any*/)
    ];
    return {
        "kind": "Fragment",
        "name": "CartItem_item",
        "type": "Item",
        "metadata": null,
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "userId",
                "type": "String!"
            },
            {
                "kind": "RootArgument",
                "name": "loadPortfolioData",
                "type": null
            },
            {
                "kind": "RootArgument",
                "name": "hasUserId",
                "type": "Boolean"
            }
        ],
        "selections": [
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "serviceId",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "isNotListed",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "isDeleted",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "seller",
                "storageKey": null,
                "args": null,
                "concreteType": "Seller",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "isClosed",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "isPending",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "isSuspended",
                        "args": null,
                        "storageKey": null
                    }
                ]
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "firstPhotoWebPath",
                "args": [
                    {
                        "kind": "Literal",
                        "name": "size",
                        "value": "large"
                    }
                ],
                "storageKey": "firstPhotoWebPath(size:\"large\")"
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "title",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "displayInfo",
                "storageKey": null,
                "args": [
                    {
                        "kind": "Variable",
                        "name": "buyerId",
                        "variableName": "userId"
                    },
                    {
                        "kind": "Literal",
                        "name": "page",
                        "value": "pdp"
                    }
                ],
                "concreteType": "ItemDisplayInfo",
                "plural": false,
                "selections": [
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "pricing",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "PriceInfoDisplay",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "showOnHold",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "showSold",
                                "args": null,
                                "storageKey": null
                            }
                        ]
                    }
                ]
            },
            {
                "kind": "FragmentSpread",
                "name": "CartItemImage_item",
                "args": null
            },
            {
                "kind": "FragmentSpread",
                "name": "CartItemTitle_item",
                "args": null
            },
            {
                "kind": "FragmentSpread",
                "name": "CartItemPricing_item",
                "args": null
            },
            {
                "kind": "FragmentSpread",
                "name": "CartItemCTA_item",
                "args": null
            },
            {
                "kind": "FragmentSpread",
                "name": "ItemFolderWrapper_item",
                "args": (v1 /*: any*/)
            },
            {
                "kind": "FragmentSpread",
                "name": "ItemHeartWrapper_item",
                "args": (v1 /*: any*/)
            },
            {
                "kind": "FragmentSpread",
                "name": "CartQuantitySelect_item",
                "args": null
            },
            {
                "kind": "Condition",
                "passingValue": true,
                "condition": "hasUserId",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "isInProcurement",
                        "args": [
                            (v0 /*: any*/)
                        ],
                        "storageKey": null
                    }
                ]
            }
        ]
    } as any;
})();
(node as any).hash = 'aea1427dc94106e4369d4d29245f6f90';
export default node;
